import { render, staticRenderFns } from "./CartProductsList.vue?vue&type=template&id=be4ad2c2&"
import script from "./CartProductsList.vue?vue&type=script&lang=js&"
export * from "./CartProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports